import { mapMutations } from 'vuex';
import { pluralizate } from '@/helpers/variables';

const STEP = 5000;
const MAX_TICKETS = 20;

export default {
  name: 'RaffleRules',
  computed: {
    currency() {
      return this.$t('label.grn');
    },
    step() {
      return STEP.toLocaleString('uk-UA');
    },
    maxLabel() {
      const word = pluralizate(
        MAX_TICKETS,
        this.$t('label.raffle.ticketOne'),
        this.$t('label.raffle.ticketSimple'),
        this.$t('label.raffle.ticketMany')
      );

      return `${MAX_TICKETS} ${word}`;
    },
    rules() {
      return [
        this.$t('label.raffle.rule1'),
        this.$t('label.raffle.rule2', { step: this.step }),
        this.$t('label.raffle.rule3', { max: this.maxLabel }),
        this.$t('label.raffle.rule4'),
        this.$t('label.raffle.rule5')
      ];
    }
  },
  methods: {
    ...mapMutations({
      modalClose: 'app/MODAL_CLOSE'
    }),
    goToCatalog() {
      document.getElementById('html').classList.remove('hide');
      this.modalClose('raffleRules');
      this.$router.push({ name: 'products' }).catch(() => {});
    }
  }
};
